import api from './api';

class SourcingRfpService {

  /*
  =============================
  RFP CRUD
  =============================
  */
  
  // Get all RFPs (with pagination + filters)
  static async getRfps(params = {}) {
    try {
      const response = await api.get('/sourcing/rfps', { params });
      return response.data;
    } catch (error) {
      console.error('Error fetching RFPs:', error);
      throw this.handleError(error);
    }
  }

  // Get single RFP
  static async getRfpById(id) {
    try {
      const response = await api.get(`/sourcing/rfps/${id}`);
      return response.data;
    } catch (error) {
      console.error('Error fetching RFP:', error);
      throw this.handleError(error);
    }
  }

  // Create RFP
  static async createRfp(data) {
    try {
      const response = await api.post('/sourcing/rfps', data);
      return response.data;
    } catch (error) {
      console.error('Error creating RFP:', error);
      throw this.handleError(error);
    }
  }

  // Update RFP
  static async updateRfp(id, data) {
    try {
      const response = await api.put(`/sourcing/rfps/${id}`, data);
      return response.data;
    } catch (error) {
      console.error('Error updating RFP:', error);
      throw this.handleError(error);
    }
  }
  
  // Publish RFP
  static async publishRfp(id) {
    try {
      const response = await api.post(`/sourcing/rfps/${id}/publish`);
      return response.data;
    } catch (error) {
      console.error('Error publishing RFP:', error);
      throw this.handleError(error);
    }
  }
   
  // frontend/services/SourcingRfpService.js

static async deleteRfp(id) {
  try {
    const response = await api.delete(`/sourcing/rfps/${id}`);
    return response.data;
  } catch (error) {
    console.error('Error deleting RFP:', error);
    throw this.handleError(error);
  }
}
  /*
  =============================
  Vendor Responses
  =============================
  */

  static async getResponses(rfpId) {
    try {
      const response = await api.get(`/sourcing/rfps/${rfpId}/responses`);
      return response.data;
    } catch (error) {
      console.error('Error fetching responses:', error);
      throw this.handleError(error);
    }
  }

  static async submitResponse(rfpId, data) {
    try {
      const response = await api.post(
        `/sourcing/rfps/${rfpId}/responses`,
        data
      );
      return response.data;
    } catch (error) {
      console.error('Error submitting response:', error);
      throw this.handleError(error);
    }
  }

  /*
  =============================
  Evaluation
  =============================
  */

  static async startEvaluation(id) {
    try {
      // This matches the route you defined in your backend controller
      const response = await api.post(`/sourcing/rfps/${id}/start-evaluation`);
      return response.data;
    } catch (error) {
      console.error('Error starting evaluation:', error);
      throw this.handleError(error);
    }
  }

  static async submitEvaluation(rfpId, data) {
    try {
      const response = await api.post(
        `/sourcing/rfps/${rfpId}/evaluation`,
        data
      );
      return response.data;
    } catch (error) {
      console.error('Error submitting evaluation:', error);
      throw this.handleError(error);
    }
  }

  static async getEvaluations(rfpId) {
    try {
      const response = await api.get(
        `/sourcing/rfps/${rfpId}/evaluation`
      );
      return response.data;
    } catch (error) {
      console.error('Error fetching evaluations:', error);
      throw this.handleError(error);
    }
  }

  /*
  =============================
  Award
  =============================
  */

  static async recommendAward(rfpId, data) {
    try {
      const response = await api.post(
        `/sourcing/rfps/${rfpId}/award`,
        data
      );
      return response.data;
    } catch (error) {
      console.error('Error recommending award:', error);
      throw this.handleError(error);
    }
  }

  static async approveAward(awardId, data) {
    try {
      const response = await api.put(
        `/sourcing/awards/${awardId}/approve`,
        data
      );
      return response.data;
    } catch (error) {
      console.error('Error approving award:', error);
      throw this.handleError(error);
    }
  }

  static async createContractFromAward(awardId) {
    try {
      const response = await api.post(
        `/sourcing/awards/${awardId}/create-contract`
      );
      return response.data;
    } catch (error) {
      console.error('Error creating contract from award:', error);
      throw this.handleError(error);
    }
  }

  /*
  =============================
  ERROR HANDLER
  (Same pattern as subcontracting)
  =============================
  */

  static handleError(error) {
    if (error.response) {
      const errorData = error.response.data;

      const errorMessage =
        errorData?.message ||
        errorData?.error ||
        (errorData?.errors?.length
          ? errorData.errors.map(e => e.msg || e.message).join(', ')
          : 'An error occurred');

      return {
        message: errorMessage,
        status: error.response.status,
        data: errorData,
      };
    }

    if (error.request) {
      return {
        message: 'Network error - please check your connection',
        status: 0,
      };
    }

    return {
      message: error.message || 'Unexpected error occurred',
      status: 0,
    };
  }
}

export default SourcingRfpService;